import React from 'react';
import styled from 'styled-components';
import { variables } from '@splunk/themes';
import { PaddedContainer } from './PaddedContainer';

export const OptionContainer = PaddedContainer;
export const OptionLabel = styled.label`
    padding-bottom: ${variables.spacingXSmall};
    font-weight: ${variables.fontWeightNormal};
    font-size: ${variables.fontSize};
    display: flex;
    justify-content: space-between;
    font-family: ${variables.fontFamily};
    color: ${variables.contentColorActive};
`;

export const OptionContent = styled.div`
    font-family: ${variables.fontFamily};
    color: ${variables.contentColorDefault};
    font-size: ${variables.fontSize};
`;

export interface OptionProps {
    label: React.ReactNode;
    children: React.ReactNode;
    depends?: () => boolean;
    'data-test'?: string;
    inputId?: string;
    labelId?: string;
}

export const Option = ({
    label,
    children,
    depends = () => true,
    'data-test': dataTestId,
    inputId,
    labelId,
}: OptionProps) => {
    if (!depends()) {
        return null;
    }
    return (
        <PaddedContainer data-test="option" data-test-id={dataTestId}>
            <OptionLabel
                data-test="option-label"
                htmlFor={inputId}
                id={labelId}
            >
                {label}
            </OptionLabel>
            <OptionContent data-test="option-content">{children}</OptionContent>
        </PaddedContainer>
    );
};

export default Option;
